const Radio = ({ checked, onClick, size = 'md' }) => {
  return (
    <div className={`comp-radio ${checked ? 'checked' : ''} size-${size}`} onClick={onClick} role="radio" aria-checked={checked}>
      <div className="radio-outer">
        <div className="radio-inner" />
      </div>
    </div>
  );
};

export default Radio;
